import { userdata } from "./table_typing"

export interface tableState {
    model:{
            user:userdata[],
        }
    view:{
        loaded: boolean, 
        autorefresh: boolean,
    }
}

export const tableInitialState = {
    model:{
        user: [] as userdata[]
        }
        ,
        view:{
            loaded: false,
            autorefresh: false,
        }
    }


export function deepCopyTableThingyState(toCopy:tableState):tableState{
    return {
        model:{
            user:toCopy.model.user.map((user) =>
            {
                return {
                    ...user,
                }
            })
        },
        view:{
            loaded:toCopy.view.loaded,
            autorefresh:toCopy.view.autorefresh
        }
    }
    
}